import { EntityTypes } from './enums/entityTypes';

export interface AssessmentScore {
  scoreId: string;
  assessmentRecordId: string;
  orgId: string;
  entityType: EntityTypes.assessmentScore;
  total: number;
  userScores: UserScoreHolder;
  created: number;
  lastUpdated: number;
}

export interface UserScoreHolder {
  [key: string]: UserScore;
}
export interface UserScore {
  userId: string;
  sectionScores: SectionScoreHolder;
  total: number;
  created: number;
  lastUpdated: number;
}

export interface SectionScoreHolder {
  [key: string]: number;
}
